import axios from 'axios'
import { Message, MessageBox } from 'element-ui'

var idcard = {}
idcard.read = function () {
  return new Promise((resolve, reject) => {
    axios.get('http://127.0.0.1:8889').then(response => {
      if (response.data.success) {
        let data = response.data.data
        data.code = data.idcard
        return resolve(data)
      } else {
        if (response.status === 504) {
          MessageBox.alert('需要下载并安装身份证阅读器插件,点击确定下载', '提示', {
            confirmButtonText: '确定',
            callback: () => {
              window.open('http://oss.jiaxiao.fun/idcard-down.html')
            }
          })
          return reject('需要安装插件')
        } else {
          Message({
            type: 'error',
            message: response.data.message
          })
          return reject(response.data.message)
        }
      }
    })
  })
}

export default idcard


// WEBPACK FOOTER //
// ./src/idcard.js